import type { DaySelection } from '@/types/RecReviewTypes';

/**
 * Generates an array of date strings (YYYY-MM-DD format) from a date range
 * and day-of-week selection.
 *
 * @param startDate - Start date (inclusive)
 * @param endDate - End date (inclusive)
 * @param daysOfWeek - Object specifying which days of the week to include
 * @returns Array of date strings in YYYY-MM-DD format
 */
export function generateDatesFromRange(
	startDate: Date,
	endDate: Date,
	daysOfWeek: DaySelection,
): string[] {
	const dates: string[] = [];
	const current = new Date(startDate);

	// Create array of day keys matching JavaScript's getDay() method
	// getDay() returns: 0=Sunday, 1=Monday, 2=Tuesday, 3=Wednesday, 4=Thursday, 5=Friday, 6=Saturday
	const dayKeys: Array<keyof DaySelection> = [
		'sunday',
		'monday',
		'tuesday',
		'wednesday',
		'thursday',
		'friday',
		'saturday',
	];

	while (current <= endDate) {
		const dayIndex = current.getDay(); // 0=Sunday, 1=Monday, etc.
		const dayKey = dayKeys[dayIndex];

		if (daysOfWeek[dayKey]) {
			// Format as YYYY-MM-DD
			dates.push(current.toISOString().split('T')[0]);
		}

		// Move to next day
		current.setDate(current.getDate() + 1);
	}

	return dates;
}
